import { render, staticRenderFns } from "./WorkspaceCreator.vue?vue&type=template&id=0a13a15a&scoped=true&"
import script from "./WorkspaceCreator.vue?vue&type=script&lang=ts&"
export * from "./WorkspaceCreator.vue?vue&type=script&lang=ts&"
import style0 from "./WorkspaceCreator.vue?vue&type=style&index=0&id=0a13a15a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a13a15a",
  null
  
)

export default component.exports